<template>
    <div class="h-[170px] md:h-[240px] bg-[#fff4f0] flex items-center justify-center relative">
        <div>
            <img class="h-20 md:mr-10 mr-4" src="/images/jtca_logo.png" alt="JTCA" />
        </div>
        <h1
            class="relative text-left text-[20px] md:text-3xl font-semibold leading-relaxed md:leading-relaxed tracking-widest">
            家族ケア専門士<br />
            認定登録申し込みフォーム
        </h1>
    </div>
</template>

<script>
export default {
    name: "FormHeader"
}
</script>

<!-- <style scoped>
.form-header-img {
    background: url('/images/jtca_logo.png') no-repeat center center;
}
</style> -->
